import React, {useContext} from "react";
import "./StartupProjects.scss";
import {bigProjects} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function StartupProject() {
  const {isDark} = useContext(StyleContext);

  if (!bigProjects.display) return null;

  function openUrlInNewTab(url) {
    if (!url) return;
    const win = window.open(url, "_blank");
    if (win) win.focus();
  }

  return (
    <Fade bottom duration={800} distance="20px">
      <section className={isDark ? "dark-mode main projects-section" : "main projects-section"} id="projects">
        <div className="editorial-heading">
          <span>03 / SELECTED WORK</span>
          <h2>{bigProjects.title}</h2>
        </div>

        <p className="project-subtitle">{bigProjects.subtitle}</p>

        <div className="projects-container">
          {bigProjects.projects.map((project, i) => (
            <article className="project-card" key={i}>
              <div className="project-number">
                {String(i + 1).padStart(2, "0")}
              </div>

              <div className="project-image">
                {project.image ? (
                  <img src={project.image} alt={project.projectName} className="card-image" />
                ) : (
                  <div className="project-image-placeholder">BACKEND / API</div>
                )}
              </div>

              <div className="project-detail">
                <p className="project-type">PROJECT {String(i + 1).padStart(2, "0")}</p>
                <h3 className="card-title">{project.projectName}</h3>
                <p className="card-subtitle">{project.projectDesc}</p>

                {project.footerLink && project.footerLink.length > 0 && (
                  <div className="project-card-footer">
                    {project.footerLink.map((link, j) => (
                      <button
                        key={j}
                        type="button"
                        className="project-tag"
                        onClick={() => openUrlInNewTab(link.url)}
                      >
                        {link.name} →
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </article>
          ))}
        </div>
      </section>
    </Fade>
  );
}
